// @flow

import React, { Component } from 'react'

import './UsersMentioned.css'
import Loading from '../Icons/loading.gif'
import { Link } from 'react-router-dom'

type Props = {
  mentions: Array<any>,
  loading: Boolean
}

/**
  * Diplay for push notifications
  * @class
  * @extends Component
*/
class UsersMentioned extends Component<Props> {
  /** render function */
  render () {
    const mentions = this.props.mentions || []
    let mentionsMessage = null
    if (mentions.length === 0) {
      mentionsMessage = 'No one was mentioned on this post'
    }
    const list = mentions.map((user) => {
      if (user.name === 'Loading' || user === 'OFFLINE') {
        return (<table key='Loading'><tbody><tr><td><img src={Loading} alt='Loading' /></td></tr></tbody></table>)
      }
      return (
        <div className='UserMentionedDisplay' key={user._id}>
          <Link to={{ pathname: '/user', search: '?id=' + user._id + '&date=Week&filter=__' }} style={{ color: '#3fa8f00', fontSize: '14px', fontWeight: 'bold' }} >
            <p>{user.name}</p>
          </Link>
        </div>
      )
    })

    let body
    if (this.props.loading) body = null
    else {
      body = <>
        {list}
        <div style={{ color: '#A3AEBD', position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 'fit-content' }}>
          {mentionsMessage}
        </div>
      </>
    }
    return (
      <div className='box' style={{ minHeight: '250px', position: 'relative' }}>
        <h4>
          USERS MENTIONED
        </h4>
        <div style={{ maxHeight: '200px', overflow: 'auto' }}>
          {body}
        </div>

      </div>
    )
  }
}

export default UsersMentioned
